import AlsoCompare from "@components/ComparisonPage/AlsoCompare";
import ComparisonTable from "@components/ComparisonPage/ComparisonTable";
import GallaboxSpotlightFeatures from "@components/ComparisonPage/GallaboxSpotlightFeatures";
import H1Text from "@components/ComparisonPage/H1Text";
import ProsConsBox from "@components/ComparisonPage/ProsConsBox";

import GallaboxVideo from "@components/GallaboxVideo";
import NewLayout from "@components/new-ui/Layout";
import { imageCard } from "@utils/comparison";
import { FC } from "react";

import HeroButton from "@components/HeroButton";

const comparative = [
    { title: "Green tick verification", tocomp: "no.png", gallabox: "Free green-tick application" },
    { title: "Chatbot Flow", tocomp: "AI Chatbot", gallabox: "Advanced Chatbot with Bot Actions" },
    { title: "Contacts Managements", tocomp: "yes.png", gallabox: "yes.png" },
    { title: "Integrations", tocomp: "verloop-integrations.png", gallabox: "gallabox-integrations.png" },
    { title: "Broadcast Scheduling", tocomp: "no.png", gallabox: "yes.png" },
    { title: "Internal Team conversations", tocomp: "yes.png", gallabox: "yes.png" },
    { title: "Canned Responses", tocomp: "yes.png", gallabox: "yes.png" },
];
const prosCons = {
    pros: ["Omnichannel support tool.", "AI multilingual chatbots to respond to customers", "Re-engagement follow-ups and reminders with automation feature."],
    cons: [
        "Being an omnichannel service provider, Verloop’s features do not specialise in WhatsApp Business Solutions.",
        "They are yet to release a shop/catalogue feature for businesses to showcase their product offerings on WhatsApp.",
        "Their chatbot builder is quite complex to manoeuvre around and takes time to build.",
        "They do not specialise in segmented targeting of customers through WhatsApp broadcasts",
    ],
};

const keyPoints = [
    "Shop on WhatsApp with Gallabox’s WhatsApp Catalogues",
    "Easy to Build No-code Chatbot with Chatbot Templates",
    "User-Friendly Team Dashboard",
    "Re-Engagement Tools like: Bulk Broadcasting, Segmented Broadcasting, Follow-up Reminders, Assignment Rules, and more",
    "Access your Gallabox account from Anywhere with Our Mobile Application.",
];

const VerloopComparison: FC = () => {
    return (
        <NewLayout
            title="Gallabox - Best Alternative to Verloop "
            description="Don't limit yourself to WhatsApp Business! With Gallabox's WhatsApp Business Solution you can leverage WhatsApp chatbot, Team inbox, WhatsApp Broadcast Integrations with E-commerce store, Zoho, Razorpay and many more. Learn why Gallabox is the best alternative to Verloop"
            canonical="https://gallabox.com/verloop-alternative"
        >
            <header className="comparisons-header mob-pad text-center py-20">
                <div className="flex justify-center items-center mb-5">
                    <div className="">
                        <img src="comparison-page/gallabox-logo.png" alt="gallabox logo" />
                    </div>{" "}
                    <span className="mx-6 text-lg font-bold">vs</span>{" "}
                    <div className="">
                        <img src="comparison-page/verloop-logo.png" alt="verloop logo" />
                    </div>
                </div>
                <H1Text content={"The Best Verloop Alternative"} />

                <div className="mt-3 lg:pt-6 text-center flex lg:gap-6 gap-3 max-w-6xl mx-auto justify-center">
                    <HeroButton buttontext="Sign up for Free" />
                </div>
            </header>
            <section className="text-center my-20 mob-pad">
                <div>
                    <h2 className=" text-3xl text-bold mb-8" style={{ color: "#1A202C", fontSize: "32px" }}>
                        Gallabox - Your All in One WhatsApp Business Tool{" "}
                    </h2>
                    <p className="text-lg text-gray-600 max-w-5xl mx-auto">
                        Gallabox is a one-stop customer support WhatsApp Business tool that empowers businesses to engage quicker and better with their customers. The multi-agent
                        team inbox supports as many agents as required with unlimited contact management and an easy-to-use no-code chatbot builder.
                    </p>
                    <p className="text-lg text-gray-600 max-w-5xl mx-auto mt-3">
                        If you have been facing any difficulties in creating a chatbot on Verloop, Gallabox’s newly launched Chatbot Templates are your quick fix. Simply select
                        from the available templates, customise it to your brand and deploy your bot.
                    </p>
                </div>
            </section>
            <section className="text-center mob-pad">
                <ComparisonTable comparative={comparative} compareWith={"verloop"} />
            </section>
            <section className="mt-10 mob-pad">
                <ProsConsBox prosCons={prosCons} compareWith={"Verloop"} />
            </section>
            <section className="mob-pad">
                <GallaboxSpotlightFeatures
                    mainTitle="Why Gallabox?"
                    description="Gallabox’s shared team inbox unleashes the superpower of WhatsApp Business APIs providing users with the best tools to increase their support, sales, marketing, and team efforts. If you are wondering why Gallabox is the WhatsApp solution you should choose alternatively to Verloop, here are some of our best offerings:"
                    imageCard={imageCard}
                    keyPoints={keyPoints}
                />
            </section>
            <section className="bg-black pb-12 mob-pad">
                <AlsoCompare toComp={"verloop"} indexNo={0} />
            </section>
            <section className="relative bg-rhino mob-pad">
                <GallaboxVideo />
            </section>
        </NewLayout>
    );
};

export default VerloopComparison;
